<template>
  <div v-if="singleDraftInfo">
    <v-row>
      <v-col md="6" sm="12" class="d-flex flex-column">
        <v-card class="flex" outlined tile>
          <v-list-item two-line>
            <v-list-item-content>
                <v-list-item-title class="headline">
                {{ $t("card.detail-info") }}
                <span v-if="parseInt(singleDraft.memo.is_izin_prinsip) === 1" class="error--text">({{$t('label.permit-memo')}})</span>
                <span v-if="parseInt(singleDraft.memo.is_bom) === 1" class="error--text">({{$t('label.bom-memo')}})</span>
                <span v-if="parseInt(singleDraft.memo.urgensi) === 1" class="secondary--text text-smaller">{{$t('label.urgent')}}</span>
                <span v-if="parseInt(singleDraft.memo.is_masuk) === 1" class="label theme-bg6 text-white f-12">{{$t('label.incoming-letter')}}</span>
                <span v-if="parseInt(singleDraft.memo.is_eksternal) === 1" class="label theme-bg3 text-white f-12">{{$t('label.external-letter')}}</span>
              </v-list-item-title>
            
              <v-list-item-subtitle
                class="blue--text text--darken-1 text-bolder"
              >
                <v-icon class="blue--text text--lighten-1">{{
                  iconInfo
                }}</v-icon>
                {{ singleDraftInfo ? singleDraftInfo.status_label : "" }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <div class="table-responsive-container">
              <div class="table-responsive info__container">
                <table class="draft__info-table">
                  <tr v-if="parseInt(singleDraft.memo.is_eksternal) !== 1">
                    <td>{{ $t("label.recipients") }}</td>
                    <td>:</td>
                    <td class="recipient__column" v-if="singleDraft.memo.is_izin_prinsip == 1">
                      <v-chip
                        v-for="item in singleDraft.izin_prinsip_details"
                        :key="item.id"
                        class="mr-1 mb-1 recipient__chip"
                      >
                        {{ item.name }}
                      </v-chip>
                    </td>
                    <td class="recipient__column" v-else>
                      <v-chip
                        v-for="item in recipients"
                        :key="item.id"
                        class="mr-1 mb-1 recipient__chip"
                      >
                        {{ item.name }}
                      </v-chip>
                    </td>
                  </tr>
                  <tr v-else>
                     <td>{{ $t("label.recipients") }}</td>
                    <td>:</td>
                    <td class="recipient__column">
                     <span>{{singleDraft.memo.kepada_line_1}}<br>
                     {{singleDraft.memo.kepada_line_2}}<br>
                     {{singleDraft.memo.kepada_line_3 ? singleDraft.memo.kepada_line_3 : '' }}
                     </span>
                     
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" style="height: 20px">&nbsp;</td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.draft-status") }}</td>
                    <td>:</td>
                    <td>
                      {{ singleDraftInfo ? singleDraftInfo.status_label : "" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.created-by") }}</td>
                    <td>:</td>
                    <td>
                      {{ singleDraftInfo ? singleDraftInfo.creator : "" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.created-at") }}</td>
                    <td>:</td>
                    <td>
                      {{
                        singleDraftInfo
                          ? indoDate(singleDraftInfo.created_at)
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" style="height: 20px">&nbsp;</td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.last-reviser") }}</td>
                    <td>:</td>
                    <td>
                      {{
                        singleDraftInfo
                          ? singleDraftInfo.last_modified.user
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.last-revised-at") }}</td>
                    <td>:</td>
                    <td>
                      {{
                        singleDraftInfo
                          ? indoDate(singleDraftInfo.last_modified.timestamp)
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("label.reviser-list") }}</td>
                    <td>:</td>
                    <td>
                      <a
                        href="javascript:;"
                        v-for="(item, idx) in revisers"
                        :key="idx"
                        class="d-block reviser__link"
                        @click="showRevisionDetails(item.id_hash, item.nama)"
                      >
                        <v-avatar left class="reviser__avatar-icon">
                          <v-icon class="blue--text text--lighten-2">{{
                            iconUser
                          }}</v-icon>
                        </v-avatar>
                        <span class="reviser__link-name">
                          {{ `${idx + 1}. ${item.nama}` }}
                        </span>
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="6" sm="12" class="d-flex flex-column">
        <v-card class="flex" outlined tile>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">
                {{ $t("card.revision-tracking") }}
              </v-list-item-title>
              <v-list-item-subtitle>{{
                $t("text.traces-the-concept")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="mx-2">
            <div class="table-responsive max-h-500" v-if="trackingList">
              <div>
                <ul class="history-awb-timeline">
                  <li v-for="(item, index) in trackingList" :key="index">
                    <div class="d-flex flex-row">
                      <div
                        class="history-date d-flex flex-column"
                        v-if="isUniqueDate(index)"
                      >
                        <p>{{ mydate(item.created_at, "dayname") }},</p>
                        <h5>{{ mydate(item.created_at, "date") }}</h5>
                      </div>
                      <div class="history-date d-flex flex-column" v-else>
                        <p></p>
                        <h5></h5>
                      </div>
                      <div class="history-detail d-flex flex-column">
                        <p style="margin: 0px">
                          {{ mydate(item.created_at, "time") }}
                        </p>
                        <p style="margin: 0px" v-html="item.action"></p>
                        <p v-html="item.desc"></p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="blue lighten-2"
              @click="showHideLogDialog(true)"
              data-hintposition="middle-middle"
            >
              <v-icon class="mr-2">{{ iconLog }}</v-icon>
              {{ $t("button.log-detail") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <log-modal
    v-bind:showLogDialog="showLogDialog"
    v-bind:memoId="singleDraft.memo.id_hash"
    v-on:showHideLogDialog="showHideLogDialog"
    ></log-modal>
    <revision-info-modal
    v-bind:showRevInfoDialog="showRevInfoDialog"
    v-bind:memoRevId="memoRevId"
    v-bind:reviserName="reviserName"
    v-on:showHideRevInfoDialog="showHideRevInfoDialog"
    ></revision-info-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import {
  mdiAccount,
  mdiAccountGroup,
  mdiInformation,
  mdiCalendarTextOutline,
} from "@mdi/js";
import LogModal from "@/components/commonComponents/LogModal.vue";
import RevisionInfoModal from '@/components/commonComponents/RevisionInfoModal.vue';
export default {
  name: "history-detail",
  components: {
    LogModal,
    RevisionInfoModal,
  },

  data: () => ({
    iconUser: mdiAccount,
    iconGroup: mdiAccountGroup,
    iconInfo: mdiInformation,
    iconLog: mdiCalendarTextOutline,
    showLogDialog: false,
    showRevInfoDialog: false,
    memoRevId: undefined,
    reviserName:undefined
  }),
  computed: {
    ...mapState("draft", ["singleDraftHistory", "singleDraftInfo","singleDraft"]),
    trackingList() {
      if (!this.singleDraftHistory) return undefined;
      return this.singleDraftHistory;
    },
    recipients() {
      if (!this.singleDraftInfo) return undefined;
      return this.singleDraftInfo.penerima;
      // let result = this.singleDraftInfo.penerima.map(({ name }) => name);
      // return result.join();
    },
    revisers() {
      if (!this.singleDraftInfo) return undefined;
      return this.singleDraftInfo.revisers;
    },
  },
  methods: {
    ...mapActions("draft", ["setDraftHistory", "getDraftHistory","setDraftLog","setSingleRevisionInfo"]),
    isUniqueDate(trackingIndex) {
      return this.checkDateTrackingItem(trackingIndex);
    },
    showHideLogDialog(val) {
     this.showLogDialog = val;
     if (!val){
       this.setDraftLog(undefined);
     }
    },
    showHideRevInfoDialog(val) {
     this.showRevInfoDialog = val;
     if (!val){
       this.memoRevId = undefined;
       this.reviserName = undefined;
       this.setSingleRevisionInfo(undefined);
     }
    },
    showRevisionDetails(revId, reviserName ){
      if (!revId) return;
      this.memoRevId = {memoId : this.singleDraft.memo.id_hash, revisionId : revId};
      this.reviserName = reviserName;
      this.showRevInfoDialog = true;
    },
    checkDateTrackingItem(trackingIndex) {
      const previousItem = this.singleDraftHistory[trackingIndex - 1];
      // const nextItem = this.trackingItems[trackingIndex + 1];
      const currentItem = this.singleDraftHistory[trackingIndex];
      if (!previousItem) {
        return true;
      }
      const prevDate = this.mydate(previousItem.created_at, "date");
      // const nextDate = nextItem ? nextItem.date : null;
      const currDate = this.mydate(currentItem.created_at, "date");

      if (prevDate !== currDate) return true;
      return false;
    },
  },
};
</script>